/**
 * Textos (`es`) de planta d'Existències (OBR-14 estats de lot, OBR-143 caducitat a la recepció): namespace `planta.stock`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts). Vocabulari: «Existències», mai «Stock».
 */

export const plantaStockEs = {
  'planta.stock': {
    writtenReason: 'Motivo: {{reason}}',
    blockedQuantity: 'Bloqueado: {{quantity}}',
    expiredOn: 'Caducado el {{date}}',
    unavailableTitle: 'Lotes que no se pueden usar',
    unavailableHint: 'Los lotes bloqueados y los caducados no se proponen ni se pueden elegir.',
    allLotsUnavailable:
      'Los lotes de este artículo están bloqueados o caducados: no se pueden usar. Un responsable puede desbloquearlos desde el BackOffice.',
    scanLotBlocked: 'El lote {{lot}} está bloqueado y no se puede usar.',
    scanLotBlockedReason: 'El lote {{lot}} está bloqueado ({{reason}}) y no se puede usar.',
    scanLotExpired: 'El lote {{lot}} está caducado y no se puede usar.',
    statesUnchecked:
      'No se ha podido comprobar qué lotes están bloqueados. Compruébalo antes de usar ninguno.',
    statesStale:
      'El estado de los lotes no se actualiza desde hace más de un día. Comprueba que ningún lote esté bloqueado.',

    expiryLabel: 'Caducidad',
    expiryMissing: 'Falta la caducidad de esta entrada.',
    expiryUseEstimate: 'Pon una caducidad estimada',
    expiryMissingSummary_one:
      'Falta la caducidad de {{count}} entrada. Ponla o usa una estimada.',
    expiryMissingSummary_other:
      'Falta la caducidad de {{count}} entradas. Ponla o usa una estimada.',
    confirmWithoutExpiry: 'Confirma sin caducidad',
    confirmWithoutExpiryHint:
      'Si no la sabes, puedes confirmar igualmente: el género entra y la existencia queda en «A regularizar» hasta que se le ponga la caducidad.',
  },
} as const;
